/**
 * Parse .constants.json values
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

/**  Imports  */
import { IToolboxConstants } from '../../types/interfaces';
import path from 'path';
import fs from 'fs';

/**  Globals  */
const Online = process.env.NODE_ENV === 'production';
const { CONSTANTS_FILE = '' } = process.env;
const FILENAME = `.constants.json`;

/**  Exports  */
export default function parseConstants<T = IToolboxConstants>(): T {
    const potential_sources = Online
        ? [path.join(process.cwd(), `${FILENAME}`)]
        : [
              path.join(process.cwd(), `../${FILENAME}`),
              path.join(process.cwd(), `../../${FILENAME}`),
              path.join(process.cwd(), `../../../${FILENAME}`),
              path.join(process.cwd(), `../../../../${FILENAME}`),
              path.join(process.cwd(), `../../../../microservices/${FILENAME}`),
              path.join(process.cwd(), `../../../microservices/${FILENAME}`),
              path.join(process.cwd(), `../../microservices/${FILENAME}`),
              path.join(process.cwd(), `../microservices/${FILENAME}`),
              path.join(process.cwd(), `${FILENAME}`),
          ];

    if (CONSTANTS_FILE) {
        potential_sources.splice(0, 0, path.join(process.cwd(), CONSTANTS_FILE));
    }

    /**
     * 1: Find file
     */
    const constants_source = potential_sources.find(src => {
        try {
            return fs.readFileSync(src);
        } catch (err) {
            // do nothing
            return false;
        }
    });

    if (!constants_source) {
        console.error(`parseConstants() failed to find ${FILENAME} file.`);
    }

    /**
     * 2: Return content
     */
    return constants_source ? JSON.parse(fs.readFileSync(constants_source, 'utf8')) : {};
}
